<div
  #keypad
  class="keypad"
  cdkDrag
  [cdkDragBoundary]="boundarySelector()"
  [cdkDragFreeDragPosition]="dragPosition()"
  (cdkDragEnded)="onDragEnded($event)"
>
  <!-- cdkDrag owns the transform of `.keypad`, so every animation lives on this inner surface instead. -->
  <div class="keypad__surface" [class.has-error]="hasError()" [class.is-verifying]="isVerifying()">
    <div class="keypad__header">
      <mat-icon class="keypad__header-icon">lock</mat-icon>
      <span class="keypad__header-title" [title]="headerTitle()">{{ headerTitle() }}</span>

      <button
        mat-icon-button
        type="button"
        class="keypad__header-button"
        [attr.aria-label]="'general.screenLock.close' | translate"
        (click)="onClose()"
      >
        <mat-icon>close</mat-icon>
      </button>

      <div class="keypad__drag-handle" cdkDragHandle [attr.aria-label]="'general.screenLock.dragToMove' | translate">
        <mat-icon>drag_indicator</mat-icon>
      </div>
    </div>

    @if (subtitle()) {
      <p class="keypad__subtitle">{{ subtitle() }}</p>
    }

    <div class="keypad__display" aria-live="polite">
      @if (isEmpty()) {
        <span class="keypad__display-placeholder">{{ 'general.screenLock.pinPlaceholder' | translate }}</span>
      } @else {
        @for (dot of pinDots(); track dot) {
          <span class="keypad__display-dot"></span>
        }
      }
    </div>

    <div class="keypad__error">
      @if (hasError()) {
        <span>{{ 'general.screenLock.wrongPin' | translate }}</span>
      }
    </div>

    <div class="keypad__keys">
      @for (digit of digitKeys; track digit) {
        <button type="button" class="keypad__key" (click)="onDigit(digit)">{{ digit }}</button>
      }

      <button
        type="button"
        class="keypad__key keypad__key--secondary"
        [disabled]="isEmpty()"
        [attr.aria-label]="'general.screenLock.backspace' | translate"
        (click)="onBackspace()"
      >
        <mat-icon>backspace</mat-icon>
      </button>

      <button type="button" class="keypad__key" (click)="onDigit('0')">0</button>

      <button
        type="button"
        class="keypad__key keypad__key--submit"
        [disabled]="!isSubmittable()"
        [attr.aria-label]="'general.screenLock.unlock' | translate"
        (click)="onSubmit()"
      >
        <mat-icon>check</mat-icon>
      </button>
    </div>

    @if (showHomeButton()) {
      <button type="button" class="keypad__home" (click)="onGoHome()">
        <mat-icon class="keypad__home-icon">home</mat-icon>
        <span>{{ 'general.screenLock.goToHome' | translate }}</span>
      </button>
    }
  </div>
</div>
